import React, { useState, useEffect } from "react";

import renderHTML from "react-render-html";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

const startDateFld = "StartDate";
const endDateFld = "EndDate";

const NotificationBanner = () => {
  const [open, setOpen] = useState(true);
  const [bannerColor, setBannerColor] = useState("#F2D478");
  const [closeIconColor, setCloseIconColor] = useState("#222222");
  const [hyperlinkAddress, setHyperLinkAddress] = useState(null);
  const [hyperlinkText, setHyperLinkText] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    //Get Notification Banner string and color based on current data
    (async () => {
      const layer = new FeatureLayer({
        url: "https://services5.arcgis.com/ajRlmtxbNBjZggOT/arcgis/rest/services/tblNotificationBanner/FeatureServer",
      });
      let now = new Date();
      let nowStr =
        now.getFullYear() +
        "-" +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + now.getDate()).slice(-2) +
        " " +
        ("0" + now.getHours()).slice(-2) +
        ":" +
        ("0" + now.getMinutes()).slice(-2) +
        ":" +
        ("0" + now.getSeconds()).slice(-2);
      let where =
        startDateFld +
        " <= TIMESTAMP '" +
        nowStr +
        "' AND " +
        endDateFld +
        " >= TIMESTAMP '" +
        nowStr +
        "' AND AppType IN (1, 2)";

      let query = layer.createQuery();
      query.where = where;
      query.outFields = ["*"];
      layer
        .queryFeatures(query)
        .then((r) => {
          const attributes = r?.features[0]?.attributes;
          if (attributes) {
            if (attributes.BannerColor) setBannerColor(attributes.BannerColor);
            if (attributes.CloseIconColor)
              setCloseIconColor(attributes.CloseIconColor);
            if (attributes.HyperlinkAddress)
              setHyperLinkAddress(attributes.HyperlinkAddress);
            if (attributes.HyperlinkText)
              setHyperLinkText(attributes.HyperlinkText);
            if (attributes.Message) setMessage(attributes.Message);
          }
        })
        .catch((err) => {
          console.warn(
            "An error has occured while searching for banner data.",
            err
          );
        });
    })();
  });

  const flexStyle = {
    position: "fixed",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "15px",
    margin: "0",
    listStyle: "none",
    backgroundColor: bannerColor,
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "1.3rem",
    color: "white",
    zIndex: "2",
  };

  const bannerText = {
    padding: "5px",
    color: "#222222",
  };

  const closeIcon = {
    marginLeft: "10px",
    padding: "5px",
    fontFamily: "Montserrat",
    textDecoration: "underline",
    fontSize: "1.4rem",
    fontWeight: "700",
    color: closeIconColor,
    cursor: "pointer",
  };

  return open && message ? (
    <ul style={flexStyle}>
      <li style={bannerText}>{renderHTML(message)}</li>
      {hyperlinkText ? (
        <li style={bannerText}>
          <a href={hyperlinkAddress} target="_blank" rel="noreferrer">
            {renderHTML(hyperlinkText)}
          </a>
        </li>
      ) : null}
      <li
        style={closeIcon}
        onClick={() => {
          setOpen(false);
        }}
      >
        Dismiss
      </li>
    </ul>
  ) : (
    <></>
  );
};

export default NotificationBanner;
